import React from 'react';
import { AlertBanner } from 'glic-ui-components';
import { date } from '../../utils/commonFunctions';

const index = ({ setDisplayBanner = true, errMsg }) => {
  return (
    <AlertBanner type="error" onClose={() => setDisplayBanner(false)}>
      We ran into some trouble getting your ID card. Refresh the page or try again later.{" "}
      ({errMsg})({date})
    </AlertBanner>
  );
};

export default index;